export default __webpack_public_path__ + "static/media/BaseLayout.homeButton.5a538a5a.png";